import React, { Component } from 'react';
import helper from '../services/helper';
import moment from 'moment';

export default class TableCell extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.formatValue(this.props.value)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: this.formatValue(nextProps.value, nextProps.type)
        });
    }

    formatValue(value, type = this.props.type) {
        switch(type) {
            case 'amount':
                return helper.formatAmount(value);
            case 'date':
                return moment(value, 'YYYYMMDD').format('D MMM gggg');
            default:
                return value;
        }
    }

    onCellBlur(event) {
        this.props.onInput({
            action: 'blur',
            rowId: this.props.rowId
        });
    }

    onCellSelect(event) {
        this.props.onInput({
            action: 'select',
            rowId: this.props.rowId
        });
    }

    onInput(event) {
        this.setState({
            value: event.target.value
        });
    }

    onBooleanClick() {
        this.setState({
            value: !this.props.value
        });

        this.props.onInput({
            action: 'input',
            key: this.props.type,
            value: !this.props.value,
            rowId: this.props.rowId
        });
    }

    validateAndConvert(userValue) {
        switch(this.props.type) {
            case 'amount':
                if(helper.isValidAmount(userValue)) {
                    return parseFloat(userValue);
                }
                break;
            case 'date':
                let date = moment(userValue);
                if(date.isValid()) {
                    return parseInt(date.startOf('day').format('ggggMMDD'), 10);
                }
                break;
            case 'day':
                let number = parseInt(userValue, 10);
                if(number > 0 && number <= 28) {
                    return number;
                }
                break;
            default:
                return userValue;
        }
        return null;
    }

    onBlur(event) {
        let finalValue  = this.validateAndConvert(event.target.value);

        if(finalValue !== null) {
            // Update database.
            this.props.onInput({
                action: 'input',
                key: this.props.type,
                value: finalValue,
                rowId: this.props.rowId
            });
        } else {
            this.props.onInput({
                action: 'warning',
                message: 'Oops, that entry is invalid.'
            });
            this.setState({
                value: this.formatValue(this.props.value)
            });
        }
    }

    render() {
        let value       = this.state.value;
        let style  = {
            cell: {
                padding: '0 10px',
                border: '1px solid #EEE',
                backgroundColor: '#FFFFFF',
                textTransform: 'capitalize'
            },
            input: {
                fontFamily: 'Overpass Mono, monospace',
                fontSize: 15,
                padding: 20
            }
        };

        switch(this.props.type) {
            case 'count':
                value = value ? <i className="fa fa-check"></i> : '';
                style.cell.padding = '20px 30px';
                return (<td onClick={this.onBooleanClick.bind(this)} style={style.cell}>{value}</td>);
            case 'title':
                value = <input style={style.input} type="text" value={value} onChange={this.onInput.bind(this)} onBlur={this.onBlur.bind(this)} autoFocus={this.props.hasAutoFocus} />;
                break;
            case 'date':
                value = <input style={style.input} type="text" value={value} onChange={this.onInput.bind(this)} onBlur={this.onBlur.bind(this)} />;
                break;
            case 'amount':
                value = <input style={style.input} type="text" value={value} onChange={this.onInput.bind(this)} onBlur={this.onBlur.bind(this)} />;
                break;
            case 'day':
                value = <input style={style.input} min="1" max="28" type="number" value={value} onChange={this.onInput.bind(this)} onBlur={this.onBlur.bind(this)} />;
                break;
            default:
                console.warn("Undefined prop type: " + this.props.type);
        }

        return (
            <td onFocus={this.onCellSelect.bind(this)} onBlur={this.onCellBlur.bind(this)} style={style.cell}>{value}</td>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TableCell.js